var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dbbdc1d59188bc8802e6edb72ffa19e0643354f1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tours@smartrent"]={id:"dbbdc1d59188bc8802e6edb72ffa19e0643354f1"};
      